import { Col, Row } from 'react-bootstrap'
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Pagination, Navigation } from 'swiper';
import { useTranslation } from 'react-i18next';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import './project.css'
import constants from "../../../contants"
const { projectsCovers } = constants
const { datavisualiaztion, inkspire, inventory, pinggo, shareeftex, serverom, dressbylinda, exposurestudio, staytoenjoy } = projectsCovers;

const featuredProjects = [
    { href: "/project/inkspire", image: inkspire.Image, alt: "Inkspire blockchain blogging platform case study" },
    { href: "/project/pinggo", image: pinggo.Image, alt: "Pinggo digital product case study" },
    { href: "/project/data-visualization", image: datavisualiaztion.Image, alt: "Industrial data visualization dashboard case study" },
    { href: "/project/dresses-by-linda-and-agnes", image: dressbylinda.Image, alt: "Dresses by Linda and Agnes Shopify case study" },
    { href: "/project/exposure-studio", image: exposurestudio.Image, alt: "Exposure Studio ecommerce design case study" },
    { href: "/project/staytoenjoy", image: staytoenjoy.Image, alt: "StayToEnjoy social ecommerce platform case study" },
    { href: "/project/shareef-tex", image: shareeftex.Image, alt: "ShareefTex catalogue design case study" },
    { href: "/project/inventory-store", image: inventory.Image, alt: "Inventory ecommerce platform case study" },
    { href: "/project/serverom", image: serverom.Image, alt: "Serverom cloud hosting platform case study" },
];

function Projects() {
    const { t } = useTranslation();

    return (
        <section className="project-section" aria-labelledby="featured-projects-heading">
            <Row>
                <Col>
                    <h2 id="featured-projects-heading" className='project-heading'>{t("casestudies")}</h2>
                </Col>
            </Row>
            <Row>
                <Col>
                    <p className="projects-description">{t("casestudiessubheading")}</p>
                </Col>
            </Row>
            <Row>
                <Swiper
                    effect={'coverflow'}
                    grabCursor={true}
                    centeredSlides={true}
                    loop={true}
                    slidesPerView={'auto'}
                    coverflowEffect={{
                        rotate: 0,
                        stretch: 0,
                        depth: 100,
                        modifier: 2.5,
                    }}
                    pagination={{ el: '.swiper-pagination', clickable: true }}
                    navigation={{
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                        clickable: true,
                    }}
                    modules={[EffectCoverflow, Pagination, Navigation]}
                    className="swiper_container"
                >
                    {featuredProjects.map((project) => (
                        <SwiperSlide key={project.href}>
                            <a href={project.href} aria-label={`View ${project.alt}`}>
                                <img style={{ objectFit: 'cover' }} src={project.image} alt={project.alt} loading="lazy" decoding="async" width={320} height={320} />
                            </a>
                        </SwiperSlide>
                    ))}
                    <div className="slider-controler">
                        <div className="swiper-button-prev slider-arrow" role="button" aria-label="Previous featured project" tabIndex={0}>
                            <span aria-hidden="true">&lt;</span>
                        </div>
                        <div className="swiper-button-next slider-arrow" role="button" aria-label="Next featured project" tabIndex={0}>
                            <span aria-hidden="true">&gt;</span>
                        </div>
                        <div className="swiper-pagination"></div>
                    </div>
                </Swiper>
            </Row>
        </section>
    )
}

export default Projects
